import { $activeTool, TOOLS, setActiveTool } from '@/stores/toolStore';
import { Icon } from '@iconify/react';
import { useStore } from '@nanostores/react';

export function ToolPanel() {
  const activeTool = useStore($activeTool);

  return (
    <aside className="pointer-events-auto rounded-xl border border-white/20 bg-[#08111fcc] p-2 backdrop-blur-sm">
      <p className="mb-2 px-1 text-xs tracking-[0.12em] text-white/80 uppercase">
        Tools
      </p>
      <div className="flex items-center gap-1">
        {TOOLS.map(tool => {
          if (!('icon' in tool)) return null;
          const active = activeTool === tool.id;

          return (
            <button
              key={tool.id}
              type="button"
              aria-label={tool.label}
              aria-pressed={active}
              onClick={() => setActiveTool(tool.id)}
              className={`flex h-10 w-10 items-center justify-center rounded-md border transition ${
                active
                  ? 'border-[#c6f3ff]/80 bg-[#2f6d85] text-[#e8f9ff]'
                  : 'border-white/20 bg-white/5 text-white/80 hover:bg-white/10'
              }`}
            >
              <Icon icon={tool.icon} className="h-5 w-5" />
            </button>
          );
        })}
      </div>
    </aside>
  );
}
